import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PropTypes } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import GridCell from '~/components/GridCell';
import * as S from './styles';
import Dropzone from '~/components/Form/Dropzone';
import Form from '~/components/Form';
import { changeLogo, deleteLogo } from '~/services/api';
import { getUserRequest } from '~/store/modules/user/actions';

export default function AddLogoModalContent({ closeModal }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [image, setImage] = useState();
  const [loading, setLoading] = useState(false);
  const { user } = useSelector(state => state.user);

  const areas = {
    xs: '"LOGO" "HEADER" "DROP" "ADVISE" "DELETE_LOGO" "SUBMIT" "CANCEL"',
    lg:
      '"LOGO LOGO" "HEADER HEADER" "DROP DROP" "ADVISE ADVISE" "DELETE_LOGO DELETE_LOGO" "SUBMIT SUBMIT" "CANCEL CANCEL"',
  };

  const handleSubmit = async e => {
    const formData = new FormData();
    e.preventDefault();
    formData.append('file', image);

    setLoading(true);

    try {
      await changeLogo(formData);
      closeModal();
    } finally {
      dispatch(getUserRequest());
      setLoading(false);
    }
  };

  const handleDeleteLogo = async () => {
    setLoading(true);
    try {
      await deleteLogo();
      closeModal();
    } finally {
      dispatch(getUserRequest());
      setLoading(false);
    }
  };

  return (
    <Form
      width={100}
      columns={2}
      onSubmit={e => {
        handleSubmit(e);
      }}
      areas={areas}
    >
      <GridCell area="LOGO" centered>
        <S.FormHeader>
          <S.Logo />
          <S.FormTitle>
            {user.logo ? t('changeLogo') : t('addLogo')}
          </S.FormTitle>
        </S.FormHeader>
      </GridCell>
      <GridCell area="HEADER" centered>
        <S.SmallNotification>{t('addImage')}</S.SmallNotification>
      </GridCell>
      <GridCell area="DROP">
        <Dropzone setImage={setImage} disabled={loading} />
      </GridCell>
      <GridCell area="ADVISE">
        <S.Advice>{t('profesionalAdvise')}</S.Advice>
      </GridCell>
      {user.logo && (
        <GridCell area="DELETE_LOGO" centered>
          <S.SubmitButton
            type="button"
            onClick={handleDeleteLogo}
            disabled={typeof image !== 'undefined'}
          >
            {t('deleteLogo')}
          </S.SubmitButton>
        </GridCell>
      )}
      <GridCell area="SUBMIT" centered>
        <S.SubmitButton
          type="submit"
          disabled={typeof image === 'undefined' || loading}
        >
          {loading ? t('loading') : t('submit')}
        </S.SubmitButton>
      </GridCell>
      <GridCell area="CANCEL" centered>
        <S.CancelButton
          onClick={() => {
            closeModal();
            setLoading(false);
          }}
          type="button"
          disabled={loading}
        >
          {t('cancel')}
        </S.CancelButton>
      </GridCell>
    </Form>
  );
}

AddLogoModalContent.propTypes = {
  closeModal: PropTypes.func,
};

AddLogoModalContent.defaultProps = {
  closeModal: () => {},
};
